import { isImageDark } from "client/utils/isImageDark";
import { setMemeInfo, setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { getSettingsForIsDark } from "store/features/memeGenerator/utils/getSettingsForIsDark";
import { useAppDispatch } from "store/store";

export const useIsImageDark = () => {
    const dispatch = useAppDispatch();
    const handleIsImageDark = (thumbnailUrl: string, textBoxes: TextBox[]) => {
        isImageDark(thumbnailUrl).then((isDark) => {
            textBoxes.forEach((textBox) => {
                dispatch(
                    setSettings({
                        id: textBox.id,
                        ...getSettingsForIsDark(textBox, isDark),
                    }),
                );
            });
            dispatch(setMemeInfo({ isDark }));
        });
    };
    return { handleIsImageDark };
};
